import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import {MobileStepper, Button, Grid, Card, CardContent, Typography, withWidth} from '@material-ui/core';
import {KeyboardArrowLeft, KeyboardArrowRight} from '@material-ui/icons';
import {isWidthDown} from '@material-ui/core/withWidth';
import {autoPlay} from 'react-swipeable-views-utils';
import SwipeableViews from 'react-swipeable-views';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const styles = theme => ({
  root: {
    padding: theme.spacing.unit * 6,
    backgroundColor: theme.palette.background.darkPaper
  },
  slides: {
  },
  card: {
    boxShadow: '0px 5px 6px -3px rgba(200,200,200,0.2),0px 9px 12px 1px rgba(200,200,200,0.2),0px 3px 16px 2px rgba(200,200,200,0.2)',
    backgroundColor: theme.palette.text.primary,
    padding: theme.spacing.unit * 4,
    margin: theme.spacing.unit * 2,
  },
  chart: {
    paddingTop: theme.spacing.unit * 3,
    border: `1px solid ${theme.palette.secondary.main}`,
    height: 50,
    width: '100%'
  },
  description: {
    color: theme.palette.text.secondary
  },
  stepper: {
    backgroundColor: 'transparent',
    maxWidth: 200,
    color: theme.palette.primary.main
  },
});

class Stocks extends React.Component {

  state = {
    activeStep: 0,
  };

  handleStepChange = index => {
    this.setState({
      activeStep: index,
    });
  };

  handleNext = () => {
    this.setState(prevState => ({
      activeStep: prevState.activeStep + 1,
    }));
  };
  handleBack = () => {
    this.setState(prevState => ({
      activeStep: prevState.activeStep - 1,
    }));
  };

  render() {

    const {classes, width} = this.props;
    const maxSteps = isWidthDown('sm', width) ? 9 : 3;
    const cards = [
      <Card className={classes.card}>
        <CardContent>
          <Typography gutterBottom variant="body1" color="inherit">
            BTC/USD 1.82%
          </Typography>
          <Typography gutterBottom variant="body1" color="inherit">
            6.588.9890
          </Typography>
          <Typography variant="caption" className={classes.description}>
            Volume: 3,322 ETH
          </Typography>
          <div className={classes.chart}/>
        </CardContent>
      </Card>,
      <Card className={classes.card}>
        <CardContent>
          <Typography gutterBottom variant="body1" color="inherit">
            BTC/USD 1.82%
          </Typography>
          <Typography gutterBottom variant="body1" color="inherit">
            6.588.9890
          </Typography>
          <Typography variant="caption" className={classes.description}>
            Volume: 3,322 ETH
          </Typography>
          <div className={classes.chart}/>
        </CardContent>
      </Card>,
      <Card className={classes.card}>
        <CardContent>
          <Typography gutterBottom variant="body1" color="inherit">
            BTC/USD 1.82%
          </Typography>
          <Typography gutterBottom variant="body1" color="inherit">
            6.588.9890
          </Typography>
          <Typography variant="caption" className={classes.description}>
            Volume: 3,322 ETH
          </Typography>
          <div className={classes.chart}/>
        </CardContent>
      </Card>,
      <Card className={classes.card}>
        <CardContent>
          <Typography gutterBottom variant="body1" color="inherit">
            BTC/USD 1.82%
          </Typography>
          <Typography gutterBottom variant="body1" color="inherit">
            6.588.9890
          </Typography>
          <Typography variant="caption" className={classes.description}>
            Volume: 3,322 ETH
          </Typography>
          <div className={classes.chart}/>
        </CardContent>
      </Card>,
      <Card className={classes.card}>
        <CardContent>
          <Typography gutterBottom variant="body1" color="inherit">
            BTC/USD 1.82%
          </Typography>
          <Typography gutterBottom variant="body1" color="inherit">
            6.588.9890
          </Typography>
          <Typography variant="caption" className={classes.description}>
            Volume: 3,322 ETH
          </Typography>
          <div className={classes.chart}/>
        </CardContent>
      </Card>,
      <Card className={classes.card}>
        <CardContent>
          <Typography gutterBottom variant="body1" color="inherit">
            BTC/USD 1.82%
          </Typography>
          <Typography gutterBottom variant="body1" color="inherit">
            6.588.9890
          </Typography>
          <Typography variant="caption" className={classes.description}>
            Volume: 3,322 ETH
          </Typography>
          <div className={classes.chart}/>
        </CardContent>
      </Card>,
      <Card className={classes.card}>
        <CardContent>
          <Typography gutterBottom variant="body1" color="inherit">
            BTC/USD 1.82%
          </Typography>
          <Typography gutterBottom variant="body1" color="inherit">
            6.588.9890
          </Typography>
          <Typography variant="caption" className={classes.description}>
            Volume: 3,322 ETH
          </Typography>
          <div className={classes.chart}/>
        </CardContent>
      </Card>,
      <Card className={classes.card}>
        <CardContent>
          <Typography gutterBottom variant="body1" color="inherit">
            BTC/USD 1.82%
          </Typography>
          <Typography gutterBottom variant="body1" color="inherit">
            6.588.9890
          </Typography>
          <Typography variant="caption" className={classes.description}>
            Volume: 3,322 ETH
          </Typography>
          <div className={classes.chart}/>
        </CardContent>
      </Card>,
      <Card className={classes.card}>
        <CardContent>
          <Typography gutterBottom variant="body1" color="inherit">
            BTC/USD 1.82%
          </Typography>
          <Typography gutterBottom variant="body1" color="inherit">
            6.588.9890
          </Typography>
          <Typography variant="caption" className={classes.description}>
            Volume: 3,322 ETH
          </Typography>
          <div className={classes.chart}/>
        </CardContent>
      </Card>
    ];
    const content = isWidthDown('sm', width) ?
      cards.map((card, index) => <Grid item key={index.toString()}>{card}</Grid>)
      : [
        <Grid container direction="row" key="0" justify="center" alignItems="stretch">
          <Grid item xs={12} sm={4}>
            {cards[0]}
          </Grid>
          <Grid item xs={12} sm={4}>
            {cards[1]}
          </Grid>
          <Grid item xs={12} sm={4}>
            {cards[2]}
          </Grid>
        </Grid>
        ,
        <Grid container direction="row" key="1" justify="space-around" alignItems="center">
          <Grid item xs={12} sm={4}>
            {cards[3]}
          </Grid>
          <Grid item xs={12} sm={4}>
            {cards[4]}
          </Grid>
          <Grid item xs={12} sm={4}>
            {cards[5]}
          </Grid>
        </Grid>
        ,
        <Grid container direction="row" key="2" justify="space-around" alignItems="center">
          <Grid item xs={12} sm={4}>
            {cards[6]}
          </Grid>
          <Grid item xs={12} sm={4}>
            {cards[7]}
          </Grid>
          <Grid item xs={12} sm={4}>
            {cards[8]}
          </Grid>
        </Grid>
      ];

    return (
      <div className={classes.root}>
        <Grid container direction="column" justify="space-evenly" alignItems="center">
          <Grid item xs>
            <AutoPlaySwipeableViews index={this.state.activeStep}
                                    onChangeIndex={this.handleStepChange}
                                    className={classes.slides}
                                    interval={5000}>
              {content}
            </AutoPlaySwipeableViews>
          </Grid>
          <Grid item>
            <MobileStepper steps={maxSteps}
                           position="static"
                           activeStep={this.state.activeStep}
                           className={classes.stepper}
                           nextButton={
                             <Button size="small" onClick={this.handleNext}
                                     variant="text"
                                     color="primary"
                                     disabled={this.state.activeStep === maxSteps - 1}>
                               <KeyboardArrowRight/>
                             </Button>
                           }
                           backButton={
                             <Button size="small" onClick={this.handleBack}
                                     variant="text"
                                     color="primary"
                                     disabled={this.state.activeStep === 0}>
                               <KeyboardArrowLeft/>
                             </Button>
                           }
            />
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default withWidth()(withStyles(styles)(Stocks));
